<mat-card-content class="banner-content">
  <div class="banner-left">
    <div class="banner-text">
      <div class="welcome">Welcome {{ firstName }} {{ lastName }}!</div>
      <h1 class="headline">Realise your potential</h1>
    </div>
  </div>
  <div class="banner-right">
    <img src="assets/img/contractorDashboard.png" alt="Team collaborating" />
  </div>
</mat-card-content>

<div class="dashboard-container">
  <mat-card>
    <mat-card-content>
      <app-contractor-leave></app-contractor-leave>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-content>
      <app-contractor-timesheet></app-contractor-timesheet>
    </mat-card-content>
  </mat-card>
</div>